import { createFileRoute, Outlet } from "@tanstack/react-router";

function SupportLayout() {
  return <Outlet />;
}

export const Route = createFileRoute("/app/settings/user/support")({
  component: SupportLayout,
});
